module.exports = __webpack_public_path__ + "static/media/ic_calendar_prev.a8622d06.svg";